import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { useRouter, RouterProps } from './useRouter'
import Home from 'screens/Home/Home'
import Category from 'screens/Category/Category'
import Landing from 'screens/Landing/Landing'
import TermsAndConditions from 'screens/TermsAndConditions/TermsAndConditions'
import PrivacyPolicy from 'screens/PrivacyPolicy/PrivacyPolicy'
import Cart from 'screens/Cart/Cart'
import Checkout from 'screens/Checkout/Checkout'

const Router: React.FC<RouterProps> = (props: RouterProps) => {
  const {} = useRouter(props)

  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Landing />} />
        <Route path='/terms-and-conditions' element={<TermsAndConditions />} />
        <Route path='/privacy-policy' element={<PrivacyPolicy />} />
        <Route path='/:restaurantName/*' element={<Home />} />
        <Route path='/:restaurantName/Cart' element={<Cart />} />
        <Route path='/:restaurantName/Checkout' element={<Checkout />} />
        <Route
          path=':restaurantName/Category/:subCategoryId'
          element={<Category />}
        />
      </Routes>
    </BrowserRouter>
  )
}

export default Router
